import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onDbBusy } from '../services/api';

import { CloseBtn } from '../components/GhostBits';
// GES-403 follow-up: the API shed a read as overloaded (503 DB_BUSY) and the bounded retry in services/busyRetry gave up.
// One shared banner for every screen (list screens that swallow read errors would otherwise look empty): message + Retry (reload).
export default function DbBusyBanner() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  useEffect(() => onDbBusy(() => setOpen(true)), []);
  if (!open) return null;
  return <div className="toast show" role="alert" style={{ pointerEvents: 'auto', bottom: 'auto', top: 60, zIndex: 200 }}>
    <span>{t('state.dbBusy')}</span>
    <button type="button" onClick={() => window.location.reload()} style={{ font: 'inherit', fontWeight: 700, cursor: 'pointer', padding: '3px 10px', borderRadius: 6, border: '1px solid currentColor', background: 'transparent', color: 'inherit' }}>{t('state.dbBusyRetry')}</button>
    <CloseBtn onClick={() => setOpen(false)} />
  </div>;
}
